const isIOS = (() => {
  return navigator.userAgent.indexOf('iPhone') > -1
})()

const isAndroid = (() => {
  return navigator.userAgent.indexOf('Android') > -1
})()

const parseContent = (text) => {
  if (text) {
    // 创建一个新的DOM解析器
    const parser = new DOMParser();

    // 将HTML解析为DOM对象
    const doc = parser.parseFromString(text, "text/html");

    // 获取所有<style>标签并将其移除
    const styleTags = doc.querySelectorAll("style");

    styleTags.forEach((styleTag) => {
      styleTag.remove();
    });

    // 获取文档的纯文本内容
    const plainText = doc.body.textContent || "";

    return plainText;
  }
  return "";
}

const isApp = (() => {
  return window.navigator.userAgent.indexOf("uni-app Html5Plus") > -1;
})();

export {
  isIOS,
  isAndroid,
  parseContent,
  isApp
}